export default __webpack_public_path__ + "static/media/2.abcd58c4.png";